const locationsPage = {
  en: {
    organizations: {
      title: 'Organizations',
      createOrgBtn: 'Create new organization',
      searchPlaceholder: 'Start typing org name...',
      clearBtn: 'Clear results',
      noSearchResult: 'No results for "{msg}"',
      create: {
        title: 'Create new organization',
        orgName: 'Organization name',
        orgPlaceholder: 'Type name...',
        createMsg: 'New organization {msg} was successfully created.',
        createBtn: 'Done',
        cancelBtn: 'Cancel',
      },
      tabs: {
        active: {
          title: 'Organizations',
          noResultsTitle: 'No organizations',
          noResultsSubtitle: 'No organizations yet',
        },
        blocked: {
          title: 'Blocked organizations',
          noResultsTitle: 'No deactivated organizations',
          noResultsSubtitle: 'Users of deactivated organizations don’t have access to tembo panel',
        },
      },
      table: {
        orgNameHeader: 'Organization name',
        locationsHeader: 'Locations',
      },
    },
    locations: {
      title: 'Locations',
      deactivateOrg: 'Deactivate organization',
      createLocationBtn: 'Create new location',
      searchPlaceholder: 'Start typing...',
      tabs: {
        locations: {
          title: 'Locations ({msg})',
          locationHeader: 'Location name',
          memberHeader: 'Member',
          noLocationsTitle: 'No locations here',
          noLocationsSubtitle: 'This organization doesn’t have any locations within it.',
        },
        admins: {
          title: 'Admins ({msg})',
          adminHeader: 'Admins',
          emailHeader: 'Email',
          createBtn: 'Create new admin',
          noAdminTitle: 'No admins at organization {msg}',
          noAdminSubtitle:
            'This organization doesn’t have any admins. Admins can manage locations and users within it.',
          editBtn: 'Edit',
        },
      },
      create: {
        title: 'Create new location',
        step: 'Step',
        stepCount: '/2',
        cancelBtn: 'Cancel',
        nextBtn: 'Next',
        createBtn: 'Create',
        locationCreateMsg: 'New location {msg} has been successfully created',
        messagesUpdateMsg: 'Messages have been successfully updated',
        mainInfoForm: {
          title: 'Main information',
          locationName: 'Location name',
          phoneNumber: 'Phone number',
          faxNumber: 'Fax number',
          pinNumber: 'Pin number',
          pinNumberPlaceholder: '****',
        },
        addressForm: {
          title: 'Address',
          streetAddressTitle: 'Street address',
          streetAddressPlaceholder: 'Street and number',
          city: 'City',
          state: 'State',
          zipCodeTitle: 'ZIP code',
          zipCodePlaceholder: '00000',
        },
        validation: {
          required: 'Required',
          phoneNumber: 'Incorrect phone number',
        },
        messagesCard: {
          clinicianMessageTitle: 'Add custom message for clinicians',
          locationMessageTitle: 'Add custom message for patients',
          clinicianMessageSubtitle:
            'You can add custom message which will be shown to clinician once he starts an visit',
          locationMessageSubtitle:
            'You can add custom message which will be shown to patient once he requests an urgent visit',
          bodyTextTitle: 'Body text',
          bodyTextPlaceholder: 'Free text goes here..',
        },
      },
      location: {
        title: 'Active users',
        organizations: 'Organizations',
        allUsersTab: 'All users ({msg})',
        qrCodeBtn: 'Open location QR-code',
        addUserBtn: 'Add existing user',
        createUserBtn: 'Create new user',
        editLocationBtn: 'Edit location info',
        userAddedMsg: 'The user has been successfully added',
        info: {
          address: 'Address',
          faxNumber: 'Fax number',
          phoneNumber: 'Phone number',
          locationMessage: 'Location message',
          clinicianMessage: 'Clinician message',
          pinNumber: 'Pin number',
          aliasId: 'Alias ID',
        },
        userTable: {
          adminHeader: 'Admins',
          emailHeader: 'Email',
          roleHeader: 'Role',
          editBtn: 'Edit',
          clearBtn: 'Clear results',
          noResults: 'No results for "{msg}"',
          noResultsTitle: 'No users at this location',
          noResultsSubitle: 'This location doesn’t have any users yet.',
        },
        qrCode: {
          title: 'QR-code types',
          back: 'Back',
          selectCampaign: 'Select version',
          mediums: 'Mediums',
          showBtn: 'Show',
          showWithoutType: 'Show without QR-code types',
          scanQrCode: 'Scan QR-code to request urgent care visit',
          downloadQrCode: 'Dowload this QR-code',
        },
        existingUser: {
          title: 'Adding existing user to',
          usersHeader: 'Users',
          emailHeader: 'Email',
          addBtn: 'Add',
          selectRole: 'Select role(s) for this user within {msg}:',
          confirmBtn: 'Confirm',
        },
        edit: {
          back: 'Back',
          title: 'Edit location',
          startTyping: 'Start typing name..',
          nextBtn: 'Next',
          doneBtn: 'Done',
          step: 'Step',
          stepCount: '/2',
          locationUpdateMsg: 'The location {msg} has been successfully edited',
          messagesUpdateMsg: 'Messages have been successfully updated',
        },
        user: {
          info: {
            title: 'Additional information:',
            organizations: 'Organizations',
            email: 'Email',
            phone: 'Phone',
            actions: {
              title: 'Available actions:',
              edit: 'Edit profile',
              resetPassword: 'Reset password',
              block: 'Block user',
              unblock: 'Unblock user',
              delete: 'Delete',
            },
            participations: 'Participations:',
            removeBtn: 'Remove from location',
            orgTitle: 'Organization',
            locationTitle: 'Location',
            popupMsg: {
              status: 'Status has been changed',
              reset: 'Password reset link was sent to {msg}’s email.',
              delete: '{user} has been successfully deleted from ${location}.',
              resetTitle: 'Are you sure you want to reset password for {msg}?',
              resetSubtitle: `This will immediately reset the user's password and send them an email with their new password. Continue?`,
              deleteTitle: 'Are you sure you want to delete {user} from {location}?',
              deleteSubtitle: `You won't be able to recover this user or do any actions. This user will no longer be discoverable in the user panel.`,
            },
          },
          create: {
            title: 'Creating new user',
            cancelBtn: 'Cancel',
            createBtn: 'Create',
            selectRoleMsg: 'Select user role(s)',
            infoMsg:
              'Role of admin gives user permissions to add, block, delete and edit users within current location.',
            userCreateMsg: 'New user {msg} has been successfully created.',
            infoForm: {
              mainTitle: 'Main information',
              rolesTitle: 'Roles',
              firstName: 'First name',
              lastName: 'Last name',
              email: 'Email',
              phone: 'Phone number',
              selectRole: 'Select role(s) for this user within {msg}:',
              validation: {
                required: 'Required',
                phone: 'Incorrect phone number',
                email: 'Incorrect email',
              },
            },
          },
          edit: {
            title: 'Edit user',
            cancelBtn: 'Cancel',
            updateBtn: 'Update and exit',
            selectRoleMsg: 'Select user role(s)',
            userUpdateMsg: '{msg}  has been successfully updated.',
          },
        },
      },
      deactivatedMsg: '{msg} has been successfully deactivated',
    },
    errorMsg: 'Something went wrong',
  },
}
export default locationsPage
